import { Middleware } from "@nuxt/types"
import { isSitecoreRequest } from "~/utils/isSitecoreRequest"

const fetchUser: Middleware = async ({ store, req, error }) => {
  if (isSitecoreRequest(req)) {
    return
  }

  const hasToken = !!store.state.oauth.accessToken
  const hasTokenAndUser = hasToken && !!store.getters.currentUser

  if (!hasToken || hasTokenAndUser) {
    return
  }

  try {
    await store.dispatch('user/fetchUser')
  } catch ({ message }) {
    return error({ statusCode: 401, message })
  }
}

export default fetchUser
